module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr-horizontal-reverse.c9b923f8aaded26e.svg";